export enum MapProjection {
    EPSG_3006 = 'EPSG:3006',    // SWEREF99 TM
    EPSG_4326 = 'EPSG:4326',    // WGS 84 / LatLong
    EPSG_25833 = 'EPSG:25833',  // ETRS89 / UTM zone 33N
    EPSG_32633 = 'EPSG:32633'   // WGS 84 / UTM zone 33N
}